import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 8.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.2,
			cy: 12,
			r: 1.15,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 1.15,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15.8,
			cy: 12,
			r: 1.15,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgMoreCircle);
export default ForwardRef;
